import { TypographyVariant as CssModulesTypographyVariant } from '@sunwebgroup/uds-ui/typography'
import { StyledTypographyWithModifiers } from './TypographyWrapper'
/**
 * @deprecated This type alias is deprecated and exists only for backward compatibility. Please use types from '@sunwebgroup/uds-ui/typography' instead.
 */
export type TypographyVariant = CssModulesTypographyVariant

/**
 * @deprecated This component is deprecated and exists only to provide backward compatibility for code that previously relied on styled-components. Please use the corresponding component from '@sunwebgroup/uds-ui/typography' instead.
 */
export const Typography = StyledTypographyWithModifiers
